import Layout from "antd/lib/layout";
import { withRouter } from "react-router-dom";
import Input from "antd/lib/input";
import { LogoutOutlined } from "@ant-design/icons";
import { BackTop } from "antd";

const {
    Header,
    Footer,
    Sider,
    Content
} = Layout;

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#1088e9',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
  };
  
const CoreLayout = (props) => {

    const isHeaderVisible = !window.location.pathname.includes("auth");
    return (
		<Layout style={{ height: "100%" }}>
			<Layout theme="light">
				{isHeaderVisible ? (
					<Sider width={200} theme="light">
						{props.menu}
					</Sider>
				) : null}
				<Content
					style={{
						height: "100vh",
						overflow: "auto",
						padding: "24px",
					}}
				>
					<BackTop>
						<div style={style}>UP</div>
					</BackTop>
					{props.children}
				</Content>
			</Layout>
		</Layout>
	);
}
export default withRouter(CoreLayout);